export const CREDIT_CARD_TRANSLATIONS = {
    "cs": {
        "creditCardLabel": "Číslo kreditní karty",
        "creditCardRequiredErrorMessage": "Povinný údaj"
    },
    "da": {
        "creditCardLabel": "Kortnummer",
        "creditCardRequiredErrorMessage": "Dette felt skal udfyldes."
    },
    "de": {
        "creditCardLabel": "Kreditkartennummer",
        "ibanLabel": "IBAN",
        "creditCardRequiredErrorMessage": "Dieses Feld muss ausgefüllt werden."
    },
    'en': {
        'creditCardLabel': 'Credit Card Number',
        "ibanLabel": "IBAN",
        'invalidErrorMessage': 'The credit card number you have provided is not valid.',
        'nonDigitErrorMessage': 'The credit card number you have provided is not valid. Only digits are allowed.',
        'creditCardRequiredErrorMessage': 'This field is required.'
    },
    'es': {
        'creditCardLabel': 'Número de tarjeta de crédito',
        "ibanLabel": "IBAN",
        'invalidErrorMessage': 'El número de tarjeta de crédito que proporcionó no es válido.',
        'nonDigitErrorMessage': 'El número de tarjeta de crédito que proporcionó no es válido. Solo se permiten dígitos.',
        'creditCardRequiredErrorMessage': 'Este campo es requerido.'
    },
    "es_VE": {
        "creditCardRequiredErrorMessage": "Es una área requeria"
    },
    "fi": {
        "creditCardLabel": "Luottokortin numero",
        "creditCardRequiredErrorMessage": "Tämä kenttä on pakollinen."
    },
    "fr": {
        "creditCardLabel": "Numero de la carte de credit",
        "ibanLabel": "IBAN",
        "creditCardRequiredErrorMessage": "Ceci est un champ obligatoire."
    },
    "fr_CA": {
        "creditCardLabel": "Numero de la carte de credit"
    },
    "hu": {
        "creditCardLabel": "Hitelkártya száma",
        "creditCardRequiredErrorMessage": "E mező kitöltése kötelező."
    },
    "in": {
        "creditCardLabel": "Credit Card Number",
        "creditCardRequiredErrorMessage": "This field is required."
    },
    "is": {
        "creditCardLabel": "Kortanúmer",
        "creditCardRequiredErrorMessage": "Þessa eyðu má ekki skilja eftir auða."
    },
    "it": {
        "creditCardLabel": "Numero carta di credito",
        "ibanLabel": "IBAN",
        "creditCardRequiredErrorMessage": "Questo è un campo obbligatorio."
    },
    "iw": {
        "creditCardLabel": ":מספר כרטיס אשראי",
        "creditCardRequiredErrorMessage": "This field is required."
    },
    "ja": {
        "creditCardLabel": "クレジットカード番号：",
        "creditCardRequiredErrorMessage": "この項目は必須です。"
    },
    "ms": {
        "creditCardLabel": "Credit Card Number",
        "creditCardRequiredErrorMessage": "This field is required."
    },
    "nl": {
        "creditCardLabel": "Nummer kredietkaart",
        "ibanLabel": "IBAN",
        "creditCardRequiredErrorMessage": "Dit veld is verplicht."
    },
    "no": {
        "creditCardLabel": "Betalingskortnummer",
        "creditCardRequiredErrorMessage": "Dette er et obligatorisk felt."
    },
    "pl": {
        "creditCardLabel": "Numer karty kredytowej",
        "creditCardRequiredErrorMessage": "To pole należy obowiązkowo wypełnić."
    },
    "pt": {
        "creditCardLabel": "Número do Cartão de Crédito",
        "ibanLabel": "IBAN",
        "creditCardRequiredErrorMessage": "Campo é obrigatório"
    },
    "ro": {
        "creditCardLabel": "Numărul cărţii de credit",
        "creditCardRequiredErrorMessage": "Acest câmp este obligatoriu."
    },
    "ru": {
        "creditCardLabel": "Номер Кредитной Карты",
        "creditCardRequiredErrorMessage": "Это поле обязательно для заполнения."
    },
    "sk": {
        "creditCardLabel": "Císlo kreditnej karty",
        "creditCardRequiredErrorMessage": "Je potrebné vyplniť toto pole."
    },
    "sv": {
        "creditCardLabel": "Kreditkortnummer",
        "creditCardRequiredErrorMessage": "Detta fält måste ifyllas."
    },
    "th": {
        "creditCardLabel": "เลขที่บัตรเครดิต",
        "creditCardRequiredErrorMessage": "กรุณากรอกข้อมูลนี้ให้ครบถ้วน"
    },
    "th_SE": {
        "creditCardRequiredErrorMessage": "จำเป็นต้องกรอกช่องนี้"
    },
    "th_TH": {
        "creditCardLabel": "หมายเลขบัตรเครดิต"
    },
    "tr": {
        "creditCardLabel": "Kredi Karti Numarasi",
        "creditCardRequiredErrorMessage": "Bu alanı doldurmak zorunludur."
    },
    "uk": {
        "creditCardLabel": "Номер Кредитної Картки",
        "creditCardRequiredErrorMessage": "Це поле є обов язковим для заповнення."
    },
    "vi": {
        "creditCardLabel": "Số thẻ tín dụng",
        "creditCardRequiredErrorMessage": "Trường thông tin bắt buộc"
    },
    'zh': {
        'creditCardLabel': '信用卡号',
        "ibanLabel": "國際銀行帳戶號碼(IBAN)",
        'invalidErrorMessage': '您提供的信用卡号码无效。',
        'nonDigitErrorMessage': '您提供的信用卡号码无效。只允许数字。',
        'creditCardRequiredErrorMessage': '这是必填栏。'
    }
};
